export const reduxKey = '@@BI';
export const actionKey = '@@BI';

//# sourceMappingURL=constants.js.map